import React, { FC } from 'react';
import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListAddress: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListAddress.slug = block.slug;
ListAddress.title = block.title;
